import replace from 'lodash/replace'
import TagManager from 'react-gtm-module'
import { UtenteNode } from '@gql/graphql'

// per assicurare che gli eventi siano eseguiti sempre dopo il wSetup
let eventQueue = []
let isReady = false
let previousUrl = null

export const setTrackingReady = () => {
  isReady = false
}

export const removeTags = (str) => {
  if (str === null || str === '') return ''
  else str = str?.toString()
  return str
    ?.replace(/(<([^>]+)>)/gi, '')
    .replace(' ', '_')
    .toLowerCase()
}

const sendGTMData = (data: any): void => {
  if (data?.event != 'wSetup' && data?.event != 'virtual_pageview') {
    // se non è ancora scattato il wSetup aggiungo l'evento alla coda
    if (!isReady) {
      eventQueue.push(data)
      return
    }
  }

  TagManager.dataLayer({
    dataLayer: data,
    dataLayerName: 'dataLayer',
  })
}

export const uniformData = (param: string) =>
  replace(replace(param, / /g, '_'), /-/g, '_').toLowerCase()

export const getPageType = (page, item, path) => {
  const pageChiave = page?.chiave || ''

  let pageType = page?.chiave || 'other'

  if (pageChiave.includes('homepage')) pageType = 'homepage'

  return pageType.toLowerCase().replaceAll(' ', '_').replaceAll('-', '_')
}

const getItemPage = (page) => {
  if (page.categoria) {
    return page.categoria
  }

  if (page.news) {
    return page.news
  }

  if (page.video) {
    return page.video
  }

  return page ?? null
}

const getCurrentChannel = () => {
  return process.env.SITE_ID === '5' ? 'emak_corporate' : 'emak_group'
}

const getShopType = (pageType: string, path: string) => {
  return 'other'
}

const formatDate = (date: string) => {
  const d = new Date(date)

  const month = String(d.getMonth() + 1).padStart(2, '0') // I mesi in JavaScript vanno da 0 a 11
  const day = String(d.getDate()).padStart(2, '0')
  const year = d.getFullYear()

  return `${day}/${month}/${year}`
}

const getGTMPageProps = (paginaCorrente, router) => {
  const page = paginaCorrente?.pagina
  const item = getItemPage(paginaCorrente)
  const pagePath = router?.asPath
  const pageType = getPageType(page, item, pagePath)

  return {
    channel: getCurrentChannel(),
    pageType: pageType,
  }
}

let currentPage = {}
let currentChannel = ''

export const setPage = (page) => {
  currentPage = page
  currentChannel = 'it'
}

export const trackingSimulatore = (productType) => {
  sendGTMData({
    event: 'ga4_event',
    event_name: 'simulatore',
    product_type: productType || '',
    page_url: window.location.href,
  })
}

export const trackingGAevent = (eventName, values = {}) => {
  // const path = getPagePath(currentPage)

  const data = {
    event: 'ga4_event',
    event_name: eventName || '',
    ...values,
  }

  sendGTMData(data)
}

export const trackingGaEventNew = (eventName, values = {}) => {
  const data = {
    event: 'GA4event',
    eventName: eventName || '',
    ...values,
  }

  sendGTMData(data)
}

export const updateGTMDataLayer = (paginaCorrente, router, environment) => {
  const gtmPageProps = getGTMPageProps(paginaCorrente, router)

  sendGTMData({
    event: 'wSetup',
    environment: environment,
    cookiebot: 'true',
    new_history_url: window.location.href,
    ...gtmPageProps,
  })

  sendGTMData({
    event: 'virtual_pageview',
    document_location: window.location.href,
    document_referrer: !previousUrl ? document?.referrer || '' : previousUrl,
  })

  isReady = true
  previousUrl = window.location.href

  // dopo il wSetup eseguo tutti gli eventi della coda
  while (eventQueue.length > 0) {
    const eventData = eventQueue.shift()
    sendGTMData(eventData)
  }
}
